/**
 * @ngdoc directive
 * @name separator
 *
 * @description
 * Separator
 */
module.directive('separator', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            css: '@?',
            type: '@?',
            theme: '=?'
        },
        template:
                '<div class="aqua-separator {{css}}" ng-style="{\'background-color\': theme.color_background, \'color\': theme.color_text}" ng-class="{\'aqua-separator--compact\': type === \'compact\'}">' +
                '  <div class="grid-main grid grid-center">' +
                '    <div class="grid-12 aqua-separator--line"></div>' +
                '  </div>' +
                '</div>'
    };
});